import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi.js'
import { STORAGE_BASE_URL } from '../../utils/config.js'
import { useNavigate } from 'react-router-dom'
import { useLocation } from "react-router-dom";
import ErrorAlert from '../../components/common/ErrorAlert.jsx'
import Input from '../../components/common/Input.jsx'
import Form from '../../components/forms/Form.jsx'
import Modal from '../../components/modals/Modal.jsx'
import Button from '../../components/common/Button.jsx'
import Notification from '../../components/common/Notification.jsx'
import Spinner from '../../components/common/Spinner.jsx'

const EmpresaDetalle = () => {
    const navigate = useNavigate()
    const routeLocation = useLocation();
    const [empresa, setEmpresa] = useState([])
    // campos
    const [idEmpresa, setIdEmpresa] = useState(routeLocation.state?.id || null);
    const [rucEmpresa, setRucEmpresa] = useState('')
    const [razonSocialEmpresa, setRazonSocialEmpresa] = useState('')
    const [partidaEmpresa, setPartidaEmpresa] = useState('')
    const [domicilioEmpresa, setDomicilioEmpresa] = useState('')
    const [distritoEmpresa, setDistritoEmpresa] = useState('')
    const [provinciaEmpresa, setProvinciaEmpresa] = useState('')
    const [departamentoEmpresa, setDepartamentoEmpresa] = useState('')
    const [dniRepresentanteEmpresa, setDniRepresentanteEmpresa] = useState('')
    const [nombresRepresentanteEmpresa, setNombresRepresentanteEmpresa] = useState('')
    const [logoEmpresa, setLogoEmpresa] = useState('')
    const [logoRepresentante, setLogoRepresentante] = useState('')
    const [fotoRepresentante, setFotoRepresentante] = useState('')
    const [mensajeEmpresa, setMensajeEmpresa] = useState('')
    // Modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEditarLogoEmpresa, setMostrarModalEditarLogoEmpresa] = useState(false)
    const [mostrarModalEditarLogoRepresentante, setMostrarModalEditarLogoRepresentante] = useState(false)
    const [mostrarModalEditarFotoRepresentante, setMostrarModalEditarFotoRepresentante] = useState(false)
    // notificaiones y cargas
    const [cargando, setCargando] = useState(true)
    const [cargandoReniec, setCargandoReniec] = useState(false)
    const [error, setError] = useState('')
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false);


    // Carga inicial de la información de   la empresa
    useEffect(() => { obtenerEmpresa() }, [])

    // Función para traer información de la empresa
    const obtenerEmpresa = async () => {
        const respuesta = await consumirApi('GET', `maestros/empresa/${idEmpresa}`)
        setEmpresa(respuesta.success ? respuesta.data : [])
        setCargando(false)
    }

    // FUncion para buscar en la BD de RENIEC el DNI
    const obtenerPersona = async (dni) => {
        setDniRepresentanteEmpresa(dni)
        setNombresRepresentanteEmpresa('')
        if (dni.length === 8) {
            setCargandoReniec(true)
            const respuesta = await consumirApi('GET', `reniec/${dni}`)
            const datos = respuesta.data[0]
            if (datos) {
                setNombresRepresentanteEmpresa(datos.nombre + ' ' + datos.ape_pat + ' ' + datos.ape_mat)
            }
            setCargandoReniec(false)
        }
    }

    // funcion para registrar informacion de la empresa 
    const registrarEmpresa = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', 'maestros/empresa', formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: 'success', mensaje: 'Datos guardados con éxito' })
            limpiarCampos()
            obtenerEmpresa()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // funcion para abrir el modal de editar empresa y cargar los datos en en formlario 
    const abrirModalEditar = (id, domicilio, dniRepresentante, nombresRepresentante, mensaje) => {
        setIdEmpresa(id)
        setDomicilioEmpresa(domicilio)
        setDniRepresentanteEmpresa(dniRepresentante)
        setNombresRepresentanteEmpresa(nombresRepresentante)
        setMensajeEmpresa(mensaje)
        setMostrarModalEditar(true)
    }

    // funcion para enviar la edicion de la empresa
    const enviarEdicionEmpresa = async (e) => {
        e.preventDefault()
        const data = { domicilio_empresa: domicilioEmpresa, dni_representante_empresa: dniRepresentanteEmpresa, nombres_representante_empresa: nombresRepresentanteEmpresa, mensaje_empresa: mensajeEmpresa }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/empresa/${idEmpresa}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Datos actualizados correctamente" })
            limpiarCampos()
            obtenerEmpresa()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Función para actualizar las imágenes de la empresa
    const actualizarImagen = async (e, tipoImagen) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const url = `maestros/empresa/${tipoImagen}/${idEmpresa}`
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', url, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: `Imagen ${tipoImagen} actualizada correctamente` })
            obtenerEmpresa()
            limpiarCampos()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEditarLogoEmpresa(false)
        setMostrarModalEditarLogoRepresentante(false)
        setMostrarModalEditarFotoRepresentante(false)
        setError('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div style={{ maxHeight: 'calc(100vh - 50px)' }} className="w-full overflow-y-auto bg-gray-50">
 
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : empresa.length === 0 ? (
                <div className="ml-5">Sin datos</div>
            ) : (
                <div className="p-6 bg-gray-50">
                    {/* {datos.map((empresa) => ( */}
                        <div key={empresa.id} className="bg-white shadow-md rounded-lg p-6 border border-gray-200 space-y-6">

                            {/* Información principal */}
                            <div className="border-b border-gray-300 pb-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">RUC:</p>
                                        <p className="text-sm text-gray-600">{empresa.ruc_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Razón Social:</p>
                                        <p className="text-sm text-gray-600">{empresa.razon_social_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Partida:</p>
                                        <p className="text-sm text-gray-600">{empresa.partida_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Domicilio:</p>
                                        <p className="text-sm text-gray-600">{empresa.domicilio_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Distrito:</p>
                                        <p className="text-sm text-gray-600">{empresa.distrito_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Provincia:</p>
                                        <p className="text-sm text-gray-600">{empresa.provincia_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Departamento:</p>
                                        <p className="text-sm text-gray-600">{empresa.departamento_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">DNI Representante:</p>
                                        <p className="text-sm text-gray-600">{empresa.dni_representante_empresa}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-semibold text-sm text-gray-700 w-32">Nombre Representante:</p>
                                        <p className="text-sm text-gray-600">{empresa.nombres_representante_empresa}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="border-b border-gray-300 pb-4">
                                <div className="flex flex-col">
                                    <p className="font-semibold text-sm text-gray-700">Mensaje:</p>
                                    {empresa.mensaje_empresa.split('-').map((linea, index) => (
                                        // Evitar renderizar la primera línea vacía si existe
                                        linea.trim() && (
                                            <p
                                                key={index}
                                                className="text-sm text-gray-600 mb-3 text-justify p-2 border-l-4 border-blue-400 bg-gray-50 hover:bg-gray-100 rounded-md"
                                            >
                                                {linea.trim()}
                                            </p>
                                        )
                                    ))}
                                </div>
                            </div>

                            {/* Botón de edición */}
                            <div className='flex justify-end mt-4'>
                                <Button texto="Editar" type="update"
                                    onClick={() => abrirModalEditar(
                                        empresa.id,
                                        empresa.domicilio_empresa,
                                        empresa.dni_representante_empresa,
                                        empresa.nombres_representante_empresa,
                                        empresa.mensaje_empresa
                                    )}
                                />
                            </div>

                            {/* Imágenes de la empresa */}
                            <div className="border-t border-gray-300 pt-4">
                                <div className="flex space-x-6">
                                    <div className="text-center">
                                        <span className="font-semibold text-sm text-gray-700">Logo Empresa:</span>
                                        <img onClick={() => setMostrarModalEditarLogoEmpresa(true)}
                                            src={`${STORAGE_BASE_URL}/${empresa.logo_empresa}`}
                                            className="cursor-pointer w-32 h-32 rounded-lg object-cover shadow-sm"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <span className="font-semibold text-sm text-gray-700">Logo Representante:</span>
                                        <img onClick={() => setMostrarModalEditarLogoRepresentante(true)}
                                            src={`${STORAGE_BASE_URL}/${empresa.logo_representante}`}
                                            className="cursor-pointer w-32 h-32 rounded-lg object-cover shadow-sm"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <span className="font-semibold text-sm text-gray-700">Foto Representante:</span>
                                        <img onClick={() => setMostrarModalEditarFotoRepresentante(true)}
                                            src={`${STORAGE_BASE_URL}/${empresa.foto_representante}`}
                                            className="cursor-pointer w-32 h-32 rounded-lg object-cover shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    {/* ))} */}
                </div>

            )}

            {/* Modal para registrar empresa*/}
            <Modal isOpen={mostrarModal} title={`Registrar Datos`} onClose={limpiarCampos} sizeModal='4xl'>
                <Form onSubmit={registrarEmpresa} texto="Registrar" isSubmitting={isSubmitting}>
                    <div className='flex gap-2 flex-1'>
                        <Input name="ruc_empresa" value={rucEmpresa} label="RUC" type="number" onChange={setRucEmpresa} />
                        <div className="flex-1">
                            <Input name="razon_social_empresa" value={razonSocialEmpresa} label="Razón social" onChange={setRazonSocialEmpresa} />
                        </div>
                    </div>
                    <div className='flex gap-2'>
                        <Input name="partida_empresa" type="number" value={partidaEmpresa} label="Partida" onChange={setPartidaEmpresa} />
                        <div className="flex-1">
                            <Input name="domicilio_empresa" value={domicilioEmpresa} label="Domicilio" onChange={setDomicilioEmpresa} />
                        </div>
                        <Input name="distrito_empresa" value={distritoEmpresa} label="Distrito" onChange={setDistritoEmpresa} />
                    </div>
                    <div className='flex gap-2'>
                        <Input name="provincia_empresa" value={provinciaEmpresa} label="Provincia " onChange={setProvinciaEmpresa} />
                        <Input name="departamento_empresa" value={departamentoEmpresa} label="Departamento" onChange={setDepartamentoEmpresa} />
                        <Input name="dni_representante_empresa" value={dniRepresentanteEmpresa} label="DNI representante" type="number" onChange={obtenerPersona} carga={cargandoReniec} />
                        <Input name="nombres_representante_empresa" value={nombresRepresentanteEmpresa} label="Nombres representante" onChange={setNombresRepresentanteEmpresa} />
                    </div>
                    <Input name="mensaje_empresa" type="textarea" value={mensajeEmpresa} label="Mensaje empresa" onChange={setMensajeEmpresa} />
                    <div className='flex gap-2'>
                        <Input name="logo_empresa" label="Logo empresa" type="file" onChange={setLogoEmpresa} />
                        <Input name="logo_representante" label="Logo representante" type="file" onChange={setLogoRepresentante} />
                        <Input name="foto_representante" label="Foto representante" type="file" onChange={setFotoRepresentante} />
                    </div>
                    {
                        error && <ErrorAlert message={error} />
                    }
                </Form>
            </Modal>

            {/* Modal para editar empresa */}
            <Modal isOpen={mostrarModalEditar} title={`Actualizar Datos`} sizeModal="lg" onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionEmpresa} type="update" isSubmitting={isSubmitting} >
                    <Input name="domicilio_empresa" value={domicilioEmpresa} label="Domicilio" onChange={setDomicilioEmpresa} />
                    <Input name="dni_representante_empresa" value={dniRepresentanteEmpresa} label="DNI representante" type="number" onChange={obtenerPersona} carga={cargandoReniec} />
                    <Input name="nombres_representante_empresa" value={nombresRepresentanteEmpresa} label="Nombres representante" onChange={setNombresRepresentanteEmpresa} />
                    <Input name="mensaje_empresa" type="textarea" value={mensajeEmpresa} label="Mensaje" onChange={setMensajeEmpresa} />
                    {
                        error && <ErrorAlert message={error} />
                    }
                </Form>
            </Modal>

            {/* Modales para editar laas imagenes  */}
            <Modal isOpen={mostrarModalEditarLogoEmpresa} title="Actualizar logo empresa" onClose={limpiarCampos} >
                <Form onSubmit={(e) => actualizarImagen(e, 'logo_empresa')} isSubmitting={isSubmitting} >
                    <div className="flex gap-2">
                        <Input name="logo_empresa" type="file" onChange={setLogoEmpresa} />
                    </div>
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            <Modal isOpen={mostrarModalEditarLogoRepresentante} title="Actualizar logo representante" onClose={limpiarCampos}>
                <Form onSubmit={(e) => actualizarImagen(e, 'logo_representante')} isSubmitting={isSubmitting}  >
                    <div className="flex gap-2">
                        <Input name="logo_representante" type="file" onChange={setLogoRepresentante} />
                    </div>
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            <Modal isOpen={mostrarModalEditarFotoRepresentante} title="Actualizar foto representante" onClose={limpiarCampos}>
                <Form onSubmit={(e) => actualizarImagen(e, 'foto_representante')} isSubmitting={isSubmitting} >
                    <div className="flex gap-2">
                        <Input name="foto_representante" type="file" onChange={setFotoRepresentante} />
                    </div>
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>
        </div>
    )
}
export default EmpresaDetalle
